<template>
  <v-container>
    <v-card-actions>
      <v-card-text>
        <router-link :to="{ name: 'studentList' }">
          <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small absolute top right>
            Back To List
          </v-btn>
        </router-link>
      </v-card-text>
    </v-card-actions>
    <v-card>
      <v-form ref="form" @submit.prevent="saveFeePlan()" lazy-validation>
        <v-sheet class="overflow-y-auto mt-16">
          <v-container fluid>
            <v-row>
              <!-- <div key="1" class="inside"> -->
              <v-col cols="12" md="2" sm="4">
                <v-img :src="tots_image" width="120"></v-img>
              </v-col>
              <v-col cols="12" v-if="studentInfo.enquiryCode" sm="6" md="4" lg="2">
                <div class="grey--text text-subtitle-2 mb-1">
                  Enquiry Code
                </div>
                <div class=" mb-1 " v-text="studentInfo.enquiryCode"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Name
                </div>
                <div class=" mb-1" v-text="studentInfo.studentFirstName ? studentInfo.studentFirstName + ' ' + studentInfo.studentLastName : studentInfo.studentName"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.franchisee">
                <div class="grey--text text-subtitle-2 mb-1">
                  Franchisee Name
                </div>
                <div class=" mb-1" v-text="studentInfo.franchisee.companyName || ''"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.academicYear">
                <div class="grey--text text-subtitle-2 mb-1">
                  Academic Year
                </div>
                <div class=" mb-1" v-text="studentInfo.academicYear.academicYear || ''"></div>
              </v-col>

              <!-- </div>
              <div class="inside" key="2"> -->
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.fatherName">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Name
                </div>
                <div class="mb-1" v-text="studentInfo.fatherName"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.fatherMobile">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Mobile
                </div>
                <div class="mb-1" v-text="studentInfo.fatherMobile || ''"></div>
              </v-col>
              <v-col cols="12" md="4" v-if="studentInfo.fatherEmailID">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Email
                </div>
                <div class="mb-1" v-text="studentInfo.fatherEmailID || ''"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.gender">
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Gender
                </div>
                <div v-if="studentInfo.gender ==='Female' || studentInfo.gender ==='FEMALE'" class="text-button mb-1" v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Female' ? 'Girl' : '-'||studentInfo && studentInfo.gender && studentInfo.gender ==='FEMALE' ? 'Girl' : '-'"></div>
                <div v-if="studentInfo.gender ==='Male' || studentInfo.gender ==='MALE'" class="text-button mb-1" v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Male' ? 'Boy' : '-' || studentInfo && studentInfo.gender && studentInfo.gender ==='MALE' ? 'Boy' : '-'"></div>
                <div v-if="studentInfo.gender === null" class="mb-1">-</div>
                </div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.class">
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Class
                </div>
                <div class="mb-1" v-text="studentInfo.class || ''"></div>
              </v-col>
              <v-col cols="12" v-if="studentInfo.section" sm="6" md="4" lg="2">
                <div class="grey--text text-subtitle-2 mb-1">
                  Section / Division
                </div>
                <div class="mb-1" v-text="studentInfo.section ? studentInfo.section : 'N/A'"></div>
              </v-col>
              <!-- </div> -->
              <!-- <v-btn class="mr-3" elevation="1" color="success">
            Save
          </v-btn> -->
            </v-row>
            <v-divider></v-divider>
            <v-card class="px-2" flat>
              <v-row>
                <v-col cols="12" sm="6" lg="4" xs="12" class="my-0 py-0">
                  <v-autocomplete v-model="selectedClassID" label="Select class" menu-props="auto" :items="filteredClasses" @change="changeSections()" item-text="name" item-value="id">
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" lg="4" xs="12" class="my-0 py-0">
                  <v-autocomplete
                    key="id"
                    v-model="selectedSectionID"
                    menu-props="auto"
                    label="Select Section"
                    :items="classWiseSections"
                    @change="getStudents(franchiseeID, selectedClassID, selectedSectionID, academicYearID)"
                    item-text="name"
                    item-value="id"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="6">
                  <span class="body-2 font-weight-medium"> Select Fee Plan <span class="error--text">*</span> </span>
                  <v-select
                    class="my-0 py-1"
                    @change="getTableList"
                    :items="infoArray"
                    key="id"
                    item-value="id"
                    item-text="name"
                    placeholder="--Select--"
                    name="feePlanSelect"
                    v-model="planID"
                    :rules="feePlanRule"
                    required
                  >
                  </v-select>
                </v-col>

                <v-col cols="12" v-if="tableInfo.length > 0">
                  <v-card-component>
                    <b-table :checked-rows.sync="checkedRows" :is-row-checkable="row => row.isCompulsory !== true" checkable :striped="true" :hoverable="true" :data="tableInfo || []">
                      <template slot-scope="props">
                        <b-table-column field="Sr No" label="Sr No">{{ props.index + 1 }}</b-table-column>
                        <b-table-column :disabled="!props.row.isCompulsory" field="feeType.name" label="Fee Type">{{ props.row.feeType.name ? props.row.feeType.name : '' }}</b-table-column>
                        <b-table-column :disabled="!props.row.isCompulsory" field="amount" label="Amount">{{ props.row.amount ? props.row.amount : '' }}</b-table-column>
                        <b-table-column :disabled="!props.row.isCompulsory" field="amount" label="Concession Remark">
                          <b-select v-model="props.row.selectedConcessionRemark" placeholder="Select a concession" @input="getDisabled(props.row, props.index)">
                            <option selected value>
                              ----Select---
                            </option>
                            <option v-for="option in props.row.concessionRemark" :value="option.name" :key="option.id">
                              {{ option.name }}
                            </option>
                          </b-select>
                        </b-table-column>

                        <b-table-column field="manualConcAmountPer" label="Concession In Percentage">
                          <input
                            required
                            class="input"
                            :disabled="props.row.isDropdown"
                            placeholder="Concession In Percentage"
                            maxLength="100"
                            :max="100"
                            :min="0"
                            :max-height="600"
                            @input="exceptEValidation($event, props.row)"
                            type="number"
                            v-model="props.row.manualConcAmountPer"
                          />
                        </b-table-column>
                        <b-table-column field="concessionAmount" label="Concession Amount">
                          <input
                            required
                            class="input"
                            :disabled="props.row.isDropdown"
                            placeholder="Concession Amount"
                            maxLength="100"
                            :max="props.row.amount"
                            readonly
                            :max-height="600"
                            type="number"
                            v-model="props.row.manualConcAmount"
                        /></b-table-column>
                      </template>
                      <template slot="empty">
                        <section class="section">
                          <div class="content has-text-grey has-text-centered">
                            <p>
                              <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                            </p>
                            <p>Nothing here.</p>
                          </div>
                        </section>
                      </template>
                    </b-table>
                  </v-card-component>
                </v-col>
              </v-row>
              <v-row v-if="planID">
                <v-col cols="12" sm="12" lg="12" xs="12" class="my-0 py-0">
                  <footer class="column has-text-left">
                    <button class="button is-success" type="submit" :disabled="hasClicked">
                      Save
                    </button>
                  </footer>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-sheet>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import moment from 'moment'
import VCardComponent from '../../template/VCardComponent.vue'
export default {
  name: 'feePlanAssignment',
  components: { VCardComponent },
  props: ['studentAdmissionID', 'type', 'STUDENT_DATA'],
  data () {
    return {
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      studentInfo: {},
      dialog: true,
      paginated: false,
      valid: true,
      perPage: 10,
      loadingComponent: null,
      isCustom: false,
      infoArray: [],
      classID: '',
      classes: [],
      selectedClassID: '',
      selectedSectionID: '',
      classWiseSections: [],
      sectionID: '',
      planID: '',
      hasClicked: false,
      info: {},
      response: [],
      orderID: '',
      isConcession: false,
      franchiseeID: '',
      concessionInfo: [],
      concessionID: '',
      conAdjsuType: '',
      manualConcAmount: '',
      installmentInfo: [],
      tableInfo: [],
      checkedRows: [],
      isAssignOrder: true,
      feePlanRule: [v => !!v || ' Fee plan is required']
    }
  },
  watch: {
    planID: function (value) {
      if (_.isEmpty(value)) {
        this.concessionID = ''
        this.conAdjsuType = ''
      }
    },
    concessionID: function (value) {
      if (value === '') {
        this.concessionID = ''
        this.conAdjsuType = ''
      }
    },
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    },
    selectedClassID: async function (val) {
      await this.getAllInfo()
    }
  },

  async created () {
    let response = await http.get(`${constants.API_URL}/api/admission-fee-details/${this.studentAdmissionID}`)
    this.studentInfo = response.data.studentInfo

    this.isConcession = false
    await this.getClassList()
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    filteredClasses () {
      if (!this.studentInfo.class) return this.classes
      const currentClass = String(this.studentInfo.class).trim().toLowerCase()
      return this.classes.filter(c => String(c.name).trim().toLowerCase() !== currentClass)
    }
  },
  methods: {
    getStudents: async function () {
      if (this.franchiseeID) {
        try {
          this.isLoading = true

          let res = await http.get(
            `${constants.API_URL}/api/student-details?franchiseeID=${this.franchiseeID}&academicYearID=${this.academicYearID}&sectionID=${this.selectedSectionID}&classID=${this.selectedClassID}`
          )

          this.students = res.data
          let x = this.students.map(a => {
            a.studentEnrollment.dateOfBirth = moment(a.studentEnrollment.dateOfBirth, 'YYYY-MM-DD').format('YYYY-MM-DD')
            return a
          })
          this.students = x
          this.searchFilterArray = this.students
          this.searchFilterArray.map(obj => {
            obj.studentEnrollment.dateOfAdmission = moment(obj.studentEnrollment.dateOfAdmission).format('DD/MM/YYYY')
          })
          this.totalStudents = res.data.length
        } catch (e) {
          this.isLoading = false
          console.log('error in student api', e)
        } finally {
          this.isLoading = false
        }
      } else {
        // this.loadingComponent.close()
        this.students = []
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.selectedClassID = ''
        this.selectedSectionID = ''
        if (this.franchiseeID) {
          await this.getClassList()
          await this.getStudents(this.franchiseeID)
        }
        this.inProgress = false
      }
    },
    getDisabled: function (item, index) {
      let udatedData = item
      if (item.selectedConcessionRemark) {
        udatedData.isDropdown = false
      } else {
        udatedData.isDropdown = true
        udatedData.manualConcAmount = 0
        udatedData.manualConcAmountPer = 0
      }
      udatedData.manualConcAmount = 0
      this.tableInfo.splice(index, 1, udatedData)
    },
    saveFeePlan: async function () {
      try {
        if (!this.planID) {
          return this.$dialog.error({
            text: ` Select Plan`,
            title: 'Error'
          })
        }
        let formData = {
          feeComponentID: this.planID,

          //   isAssignOrder: this.isAssignOrder ? this.isAssignOrder : 'false',
          feeType: _.map(this.checkedRows, item => {
            let obj = {
              id: item.id,
              feeConcessionID: item.concessionID,
              concessionAmount: item.manualConcAmount
            }
            if (item.selectedConcessionRemark) {
              obj.concessionRemark = item.selectedConcessionRemark
            }
            return obj
          })
        }

        formData.admissionID = this.studentAdmissionID
        formData.classID = this.selectedClassID
        formData.sectionID = this.selectedSectionID

        if (this.concessionID) {
          formData.feeConcessionID = this.concessionID
        }

        this.loadingComponent = this.$buefy.loading.open()

        await http.post(`${constants.API_URL}/api/class-shuffle`, formData)

        this.loadingComponent.close()
        this.dialog = false
        this.$router.push({ name: 'studentfeePlanAsign', params: { studentAdmissionID: this.studentAdmissionID } })
        return this.$dialog.info({
          text: `Assigned Successfully`,
          title: 'Success'
        })
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error in fetching data : ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      }
    },
    resetForm: async function () {
      this.selectedClassID = ''
      this.selectedSectionID = ''
      this.planID = ''
      this.feeType = {}
      this.tableInfo = []
    },
    changeSections: async function () {
      try {
        this.isLoading = true
        let sectionarray = this.sections.find(obj => obj.id === this.selectedClassID)
        if (sectionarray) {
          this.classWiseSections = sectionarray.sections
        } else {
          this.classWiseSections = []
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
        await this.getAllInfo()
      }
    },
    getTableList: async function () {
      this.checkedRows = []
      if (this.planID) {
        _.map(this.infoArray, item => {
          if (item.id === this.planID) {
            this.tableInfo = item.feeComponentFeeTypeMaps
          }
        })
      } else {
        this.tableInfo = []
      }
      _.map(this.tableInfo, element => {
        element.concessionRemark = [
          { id: 1, name: 'Sibling Concession' },
          { id: 2, name: 'Staff Concession' },
          { id: 3, name: 'One-shot Payment Concession' },
          { id: 4, name: 'Referral Concession' },
          { id: 5, name: 'General / Other Concession' }
        ]
        element.selectedConcessionRemark = ''
        element.isDropdown = true
        if (element.isCompulsory === true) {
          this.checkedRows.push(element)
        }
      })
    },
    exceptEValidation: function (event, item) {
      let amountPer = event.target.value
      if (amountPer < 0) {
        amountPer = 0
      } else if (amountPer > 100) {
        amountPer = 100
      }
      item.manualConcAmountPer = amountPer
      item.manualConcAmount = ((item.amount * amountPer) / 100).toFixed(2)
    },
    getInstallmentList: async function () {
      if (this.planID) {
        await this.getInstallmentInfo()
      }
    },
    selectedConcession: async function (conID) {
      if (conID) {
        _.map(this.concessionInfo, item => {
          if (item.id === conID) {
            this.conAdjsuType = item.adjustType
          }
        })
        if (this.planID) {
          await this.getInstallmentInfoByConcessionID()
        } else {
          this.concessionID = ''
          this.conAdjsuType = ''
          return this.$dialog.error({
            text: ` Please select fee plan`,
            title: 'Error'
          })
        }
      } else {
      }
    },

    onradioChange: async function () {
      if (this.isConcession) {
        await this.getConcessionInfo()
      } else {
        this.conAdjsuType = ''
        this.concessionID = ''
        this.tableInfo = []
        this.planID = ''
      }
    },

    getAllInfo: async function () {
      try {
        this.isLoading = true
        let formData = {
          classID: this.selectedClassID,
          admissionID: this.studentAdmissionID
        }
        this.tableInfo = []
        let { data } = await http.post(`${constants.API_URL}/api/get-fee-plans`, formData)
        this.infoArray = data

        this.info = data[0] || {}

        if (this.info) {
          _.map(this.info.feeComponentFranchiseeMaps, item => {
            this.franchiseeID = item.franchiseeID
          })
        }
        if (!this.info) {
          this.total = 0
        } else {
          this.total = this.info.length
        }
      } catch (e) {
        this.dialog = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.concessionID = ''
        this.conAdjsuType = ''
        this.planID = ''
        this.tableInfo = []
        console.log('error in fetching data : ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        let response = await http.get(`${constants.API_URL}/api/student/class-section?isRequired=false`)
        this.tableInfo = []

        // let response = await http.get(`${constants.API_URL}/api/student/all-count?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&isAllValue=true`)
        const data = response.data
        this.classes = data
        this.sections = data.map(obj => {
          return {
            id: obj.id,
            sections: obj.studentSections
          }
        })

        await this.getFranchiseeList()
        await this.getAllInfo()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getConcessionInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let { data } = await http.get(`${constants.API_URL}/api/concessions?academicYearID=${this.info.academicYearID}&franchiseeID=${this.franchiseeID}`)
        this.concessionInfo = data

        this.loadingComponent.close()
        if (!this.concessionInfo) {
          this.total = 0
        } else {
          this.total = this.info.length
        }
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        this.concessionID = ''
        this.conAdjsuType = ''

        this.planID = ''
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      }
    },
    getInstallmentInfoByConcessionID: async function () {
      try {
        this.infoArray = []
        this.loadingComponent = this.$buefy.loading.open()
        let response = await http.get(`${constants.API_URL}/api/custom-fee-component?feeConcessionID=${this.concessionID}&feeComponentID=${this.planID}`)
        this.infoArray.push(response.data)

        await this.getTableList()
        this.loadingComponent.close()
        if (!this.concessionInfo) {
          this.total = 0
        } else {
          this.total = this.info.length
        }
      } catch (e) {
        this.loadingComponent.close()
        this.concessionID = ''
        this.conAdjsuType = ''
        this.planID = ''
        this.tableInfo.length = 0
        await this.getAllInfo()
        const errorMessage = (e && e.response && e.response.data.message) || e.message

        console.log('error in fetching data : ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      }
    }
  }
}
</script>
